import { GenericModal } from '@/components/Modal';
import { CalendarCard } from '@/components/CalendarCard';

export default function CalendarModal({
  clientId,
  isOpen,
  onClose,
}: {
  clientId: string;
  isOpen: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onClose: () => void;
}) {
  return (
    <GenericModal isOpen={isOpen} onClose={onClose}>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
      <CalendarCard clientId={clientId} />
    </GenericModal>
  );
}
